import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider, ToastProvider, TooltipProvider } from '@salesbee/ui';
import { createQueryClient, createTrpcClient, trpc } from './lib/trpc';
import { createAppRouter } from './router';
import '@fontsource-variable/instrument-sans';
import '@fontsource-variable/jetbrains-mono';
import './index.css';

function App() {
  const [queryClient] = useState(createQueryClient);
  const [trpcClient] = useState(createTrpcClient);
  const [router] = useState(() => createAppRouter(queryClient));
  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <TooltipProvider>
            <ToastProvider>
              <RouterProvider router={router} />
            </ToastProvider>
          </TooltipProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </trpc.Provider>
  );
}

const el = document.getElementById('root');
if (!el) throw new Error('#root element missing');
createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
